



























































import * as api from '@/api';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
    props: ['productDes'],
    data() {
        return {
            certLogosTitle: {
                data_standard: '建筑产品信息数据标准',
                blockchain: '区块链认证',
                ISO9001: 'IOS9001',
                town_country: '城乡建设产品认证',
            },
            show: false,
            productInfo: this.productDes,
        };
    },
    watch: {
        productDes: {
            handler(val) {
                this.productInfo = val;
                this.show = true;
            },
            deep: true,
        },
    },
    filters: {
        timeFormate(value) {
            return moment(value).format('YYYY/MM/DD');
        },
    },
    methods: {
        toBrandDetail() {
            this.$router.push({
                path: `/brand/${this.productInfo.brandId}`,
            });
        },
        moment() {
            return moment;
        },
        async putUserBrand(data) {
            let res;
            if (data.isConcerned) {
                res = await api.deleteUserBrand([{ brandId: data.brandId }]); // 取消品牌关注
                if (!api.error(res)) {
                    data.isConcerned = !data.isConcerned;
                    data.fansCount -= 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.putUserBrand, arguments: data }]);
                }
            } else {
                res = await api.putUserBrand([{ brandId: data.brandId }]); // 关注品牌
                if (!api.error(res)) {
                    data.isConcerned = !data.isConcerned;
                    data.fansCount += 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.putUserBrand, arguments: data }]);
                }
            }
        },
    },
});
